export enum AttachmentStatus {
  CREATED = 'CREATED',
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
}
